import HttpHandler from "@/utils/httpHandler";

export default class AiTraderApi {
    constructor() {
        this.http = new HttpHandler();
    }

    // 查询当前用户是否为白名单管理员
    isAdmin() {
        let url = '/api-news/ai-trader/is-admin';
        return this.http.get(url);
    }

    // 创建交易员
    create(data) {
        let url = '/api-news/ai-trader/create';
        return this.http.post(url, data);
    }

    // 启动交易员
    start(data) {
        let url = '/api-news/ai-trader/start';
        return this.http.post(url, data);
    }

    // 删除交易员
    delete(data) {
        let url = '/api-news/ai-trader/delete';
        return this.http.post(url, data);
    }

    // 停止交易员
    stop(data) {
        let url = '/api-news/ai-trader/stop';
        return this.http.post(url, data);
    }

    // 交易员列表
    list(params) {
        let url = '/api-news/ai-trader/list';
        return this.http.get(url, params);
    }

    // 决策历史
    decisions(params) {
        let url = '/api-news/ai-trader/decisions';
        return this.http.get(url, params);
    }

    // 资产曲线
    assetCurve(params) {
        let url = '/api-news/ai-trader/asset-curve';
        return this.http.get(url, params);
    }

    // 持仓列表
    positions(params) {
        let url = '/api-news/ai-trader/positions';
        return this.http.get(url, params);
    }

    // 绩效指标
    performance(params) {
        let url = '/api-news/ai-trader/performance';
        return this.http.get(url, params);
    }

    // 手动交易
    manualTrade(data) {
        let url = '/api-news/ai-trader/manual-trade';
        return this.http.post(url, data);
    }

    // 启动回测
    backtest(data) {
        let url = '/api-news/ai-trader/backtest';
        return this.http.post(url, data);
    }

    // 查询回测结果
    backtestResult(params) {
        let url = '/api-news/ai-trader/backtest';
        return this.http.get(url, params);
    }
}
